import {gql} from "apollo-angular";
import {baseResponse, baseResponseGraphqlField} from "../../../base.graphql";


export const fillableFormFields = `
id
      uniqueId
      name
      description
      configuration
      isActive
      isPublished
      createdAt
service {
  serviceUniqueId
  serviceName
  serviceDescription
}
formApiHtmlBody
formApiDetails {
  id
        formApiUniqueId
        formApiDescription
        formRequiresAuth
        formApiAuthType
        formApiKey
        formJwtToken
        formClientId
        formClientSecret
        formApiUrl
        govesbApiCode
}
connectedToGovesb
`


export const CREATE_FILLABLE_FORM = gql`
  mutation CreateFillableFormMutation($input: FillableFormInputObjects!) {
    createFillableFormMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${fillableFormFields}
      }
    }
  }
`


export const UPDATE_FILLABLE_FORM = gql`
  mutation UpdateFillableFormMutation($input: FillableFormInputObjects!) {
    updateFillableFormMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${fillableFormFields}
      }
    }
  }
`

export const DELETE_FILLABLE_FORM = gql`
  mutation DeleteFillableFormMutation($formUid: String!) {
    deleteFillableFormMutation(formUid: $formUid) {
      ${baseResponseGraphqlField}
    }
  }
`

export const GET_FILLABLE_FORM = gql`
  query GetFillableForms($filtering: FillableFormFilterInputObject) {
    getFillableForms(filtering: $filtering) {
      ${baseResponseGraphqlField}
      data {
        ${fillableFormFields}
      }
    }
  }
`

export const UPDATE_FORM_CONFIGURATION = gql`
  mutation UpdateFormConfigurationMutation($input: FormConfigurationInputObjects) {
    updateFormConfigurationMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${fillableFormFields}
      }
    }
  }
`

export const PUBLISH_FILLABLE_FORM = gql`
mutation PublishFormMutation($input: FormPublishInputObjects) {
  publishFormMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${fillableFormFields}
    }
  }
}
`

export const CREATE_FILLABLE_FORM_API_DETAIL = gql`
mutation CreateFormApiDetailsMutation($input: ApiDetailsInputObjects!) {
  createFormApiDetailsMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${fillableFormFields}
    }
  }
}
`
// CITIZEN GET API
export const CITIZEN_GET_FILLABLE_FORMS = gql`
  query CitizenGetFillableForms($serviceUniqueId: String) {
    citizenGetFillableForms(serviceUniqueId: $serviceUniqueId) {
      data {
        ${fillableFormFields}
      }
      response{
        ${baseResponse}
      }
    }
  }
`;


